import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { PurchaseId } from '@dreryk/egabinet-financial-settlement-published-language-api';

import { StandardTabs } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { useMedicalServicesCounterGlobalState } from '../../../../shared/counterResolver/useMedicalServicesCounterGlobalState';
import { visitSettlementTranslationKeys } from '../../../../translations';

import { MedicalServicesTable } from './MedicalServicesTable';
import { MedicalServicesTableLoader } from './MedicalServicesTable.loader';

type MedicalServicesTabOptions = {
   appointmentId: AppointmentId;
};

export const useMedicalServicesTab = (options: MedicalServicesTabOptions): JSX.Element | null => {
   const { getCounter } = useMedicalServicesCounterGlobalState();

   const settlingMedicalServicesPerformedByOneselfAvailable = protectFeature(
      'settlingMedicalServicesPerformedByOneself'
   );
   const settlingMedicalServicesPerformedByAnyPractitionerAvailable = protectFeature(
      'settlingMedicalServicesPerformedByAnyPractitioner'
   );
   const privateMedicalServicesReadOnlyAvailable = protectFeature('privateMedicalServicesReadOnly');
   const medicalServicesCount = getCounter(PurchaseId.forAppointment(options.appointmentId));

   if (
      settlingMedicalServicesPerformedByOneselfAvailable ||
      settlingMedicalServicesPerformedByAnyPractitionerAvailable ||
      (privateMedicalServicesReadOnlyAvailable && medicalServicesCount > 0)
   ) {
      return (
         <StandardTabs.Tab
            id={'medicalServices'}
            testId={'medicalServices'}
            label={visitSettlementTranslationKeys.extensions.visitHistory.medicalServicesTab.label}
            count={medicalServicesCount}
         >
            <MedicalServicesTableLoader appointmentId={options.appointmentId}>
               {({ visitSettlement }) => <MedicalServicesTable visitSettlement={visitSettlement} />}
            </MedicalServicesTableLoader>
         </StandardTabs.Tab>
      );
   }

   return null;
};
